export default "__VITE_ASSET__36dd0e4c__"